import React,{useReducer,useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'
import Product from './Product'
import {searchbyquery} from './Fetcher'
import Slider from './Slider'
const initaistate ={
 
  loading : true,
  data : [],
  error : '',

}


const reducer = (state,action)=>{
switch(action.type){
  case 'sucess' :
    return{...state,
      loading: false ,
      data: action.payload,
      error: ''
    }
case 'error' :
  return{...state,
    loading: false ,
    data: [],
    error: action.errormessage
  }
}
}







export const Searchresult = () => {
  const [ productdata , dispatch] = useReducer(reducer,initaistate)
  const[searchparams] = useSearchParams()
  const query =  searchparams.get('q')
  useEffect(()=>{
    searchbyquery({query,dispatch})
  },[query])
  console.log(productdata.data)

  const rerenderproduct=()=>{
    return  productdata.data.map(data=>(
     <Product key={data.id} data={data}/>
    
    ))
  }
  rerenderproduct()
  return (
    <div>
      <Slider/>
{ productdata.loading ? 'loading': rerenderproduct()}  
{ productdata.error ? `Error ${ productdata.error}`  : null}


    </div>
  )
}
